import { useEffect } from 'react';
import useLazyTimetableServicesQuery from './useLazyTimetableServicesQuery';

/**
 * Hook to fetch timetable services
 * @param {Object} options
 * @param {string} [options.carrier] - Optional carrier code used to confirm query validity
 * @param {string} options.date - Date in format 'YYYY-MM-DD'
 * @param {string} [options.destinationUic] - Destination UIC code
 * @param {string} [options.originUic] - Origin UIC code
 * @param {string} [options.trainNumber] - Train number
 * @returns {Object} - Object containing timetable services, errors and loading state
 * @property {Object[]|undefined} timetableServices - Array of timetable services
 * @property {boolean|undefined} loading - Loading state
 * @throws {AgentPortalError} - Throws an error if the query fails
 */
const useTimetableServicesQuery = ({ carrier, date, destinationUic, originUic, trainNumber }) => {
  const [timetableServicesQuery, { timetableServices, loading, called }] = useLazyTimetableServicesQuery();

  useEffect(() => {
    if (called) {
      return;
    }

    timetableServicesQuery({ carrier, date, destinationUic, originUic, trainNumber });
  }, [called, timetableServicesQuery, carrier, date, destinationUic, originUic, trainNumber]);

  return { timetableServices, loading };
};

export default useTimetableServicesQuery;
